<div class="modal fade" id="{{alertTruckerFilterModalId}}" tabindex="-1" role="dialog" data-bs-backdrop="static"
    aria-labelledby="alertTruckerFilterModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="alertTruckerFilterModalLabel">Alert Truckers</h5>
                <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"
                    attr.data-bs-target="{{alertTruckerFilterModalId}}"></button>
            </div>

            <div class="d-flex justify-content-between align-items-center m-1 mb-0">
                <label for="tucker" class="form-label">
                    Truckers to Notify
                </label>
                <span class="fs-12">
                    {{getSelectedTruckerCount()}}
                </span>
            </div>

            <div class="modal-body"
                style="max-height: 600px;overflow-y: auto;height: 600px; padding: inherit;margin: 6px;"
                id="originHeader">

                <div class="alertTruckerSection" style="overflow-y: auto; max-height: 150px;">
                    <table class="table table-sm table-striped"
                        style="width: 100%; border-collapse: collapse; border: none;">
                        <thead class="table-light"
                            style="position: sticky; top: 0; z-index: 1020; background-color: #f8f9fa; border: none;">
                            <tr>
                                <th scope="col" style="min-width: 20px; border: none;">
                                    <input type="checkbox" [(ngModel)]="selectAll" [ngModelOptions]="{standalone: true}" (change)="selectAllInBCc($event)">
                                </th>
                                <th scope="col" style="min-width: 120px; border: none;">Trucker</th>
                                <th scope="col" style="min-width: 120px; border: none;">Main Contact</th>
                                <th scope="col" style="min-width: 40px; border: none;">EMail</th>
                                <th scope="col" style="min-width: 40px; border: none;">Text</th>
                                <th scope="col" style="min-width: 150px; border: none;">EMail Address</th>
                                <th scope="col" style="min-width: 150px; border: none;">Text Number</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let trucker of truckerArray; index as i">
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    <input type="checkbox" (change)="selectUserInBCc($event, trucker)"
                                        [(ngModel)]="trucker.isTruckerSelected" [ngModelOptions]="{standalone: true}">
                                </td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    {{trucker.truckerName}}</td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    {{trucker.mainContact}}</td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    <input type="checkbox" [checked]="trucker.whetherToConsiderEmail"
                                        (change)="trucker.whetherToConsiderEmail = !trucker.whetherToConsiderEmail;resetTheEmailAndPhone(trucker)"
                                        [disabled]="!trucker.email">
                                </td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    <input type="checkbox" [checked]="trucker.whetherToConsiderPhone"
                                        (change)="trucker.whetherToConsiderPhone = !trucker.whetherToConsiderPhone;resetTheEmailAndPhone(trucker)"
                                        [disabled]="!trucker.phone">
                                </td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    {{trucker.email}}</td>
                                <td [class.selected-row]="trucker.isTruckerSelected" style="border: none;">
                                    {{trucker.phone}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <form [formGroup]="emailForm">
                    <label for="email" class="form-label">EMail</label>
                    <div class="border-1 p-1 mb-0" style="background-color:#e3ecf4;">
                        <div class="mb-1 row">
                            <label for="bcc" class="col-form-label-sm">Bcc:</label>
                            <div class="col-12">
                                <textarea class="form-control" name="" id="" rows="1" formControlName="bcc"></textarea>
                                <div *ngIf="(bccAddress.dirty && bccAddress.touched) && !bccValid" class="text-danger">
                                    One or more email addreses in the BCC field are invalid.
                                </div>
                            </div>
                        </div>

                        <div class="mb-1 row">
                            <label for="cc" class="col-form-label-sm">Cc:</label>
                            <div class="col-12">
                                <div class="multi-select">
                                    <div (click)="toggleDropdown()"
                                        [ngClass]="selectedValues.length === 0 ? 'unselected' : 'selected'">
                                        {{ selectedValues.length > 0 ? selectedValues.join(', ') : 'Users to notify' }}
                                    </div>

                                    <div *ngIf="isOpen" class="multi-select-options">
                                        <input type="text" placeholder="Search users.." class="search-box"
                                            (input)="filterUsers($event)" />
                                        <div *ngFor="let item of filteredUserArray" class="options">
                                            <label>
                                                <input type="checkbox" [checked]="isSelected(item.userEmail)"
                                                    (change)="toggleSelection(item.userName, item.userEmail)" />
                                                {{ item.userName}}
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                <!-- <textarea class="form-control" name="" id="" rows="2" formControlName="cc"></textarea> -->
                                <!-- <div *ngIf="(ccAddress.dirty && ccAddress.touched) && !ccValid"
                            class="text-danger">
                            One or more email addreses in the Cc field are invalid.
                        </div> -->
                            </div>
                        </div>

                        <div class="col-sm-3" *ngIf="isMobile">
                            <div style="display: flex; align-items: center;">
                                <label class="col-form-label-sm" style="margin-right: 10px;">Subject/Closing</label>
                                <ng-container>
                                    <div *ngIf="!isShowSubject" (click)="showHideSubject()">
                                        <svg enable-background="new 0 0 32 32" height="16px" version="1.1"
                                            viewBox="0 0 32 32" width="16px" xml:space="preserve"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <g id="background">
                                                <rect fill="none" height="32" width="32" />
                                            </g>
                                            <g id="arrow_x5F_down">
                                                <polygon points="2.002,10 16.001,24 30.002,10" />
                                            </g>
                                        </svg>
                                    </div>
                                    <div *ngIf="isShowSubject" (click)="showHideSubject()">
                                        <svg enable-background="new 0 0 32 32" width="16px" height="16px" version="1.1"
                                            viewBox="0 0 32 32" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                                            <g id="backbord">
                                                <rect fill="none" height="32" width="32" />
                                            </g>
                                            <g id="arrow_x5F_up">
                                                <polygon points="30,22 16.001,8 2.001,22" />
                                            </g>
                                        </svg>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <ng-container *ngIf="(isMobile && isShowSubject) || !isMobile">
                            <div class="mb-1 row">
                                <label for="subject" class="col-form-label-sm">Subject:</label>
                                <div class="col-12">
                                    <input type="text" class="form-control" formControlName="subject"
                                        style="background-color: #fff2cc;">
                                </div>
                            </div>

                            <div class="row">
                                <label for="closing" class="col-form-label-sm">Closing:</label>
                                <div class="col-12">
                                    <textarea class="form-control" style="background-color: #fff2cc;" name=""
                                        formControlName="closing" id="" rows="2"></textarea>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <label for="telephone" class="form-label">Text Message</label>
                    <div class="border-1 p-1 mb-0" style="background-color:#e3ecf4;">
                        <div class="mb-1 row">
                            <label for="telephone" class="col-form-label-sm">Text to:</label>
                            <div class="col-12">
                                <textarea class="form-control" name="" id="" rows="1" readonly
                                    style="background-color: #d3d3d3;" formControlName="telephone"></textarea>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 ">
                        <div class="d-flex" style="justify-content: space-between">
                            <label for="" class="form-label">Message</label>
                            <span class="fs-12">{{emailForm.get('message')?.value?.length}}/{{messageMaxLength}}</span>
                        </div>
                        <textarea class="form-control" style="background-color: #fff2cc;" rows="3"
                            formControlName="message"></textarea>
                        <div *ngIf="(emailForm.get('message').dirty && emailForm.get('message').touched) && emailForm.get('message')?.errors?.['required']"
                            class="text-danger">
                            Message is required.
                        </div>
                        <div *ngIf="(emailForm.get('message').dirty && emailForm.get('message').touched) && emailForm.get('message')?.errors?.['maxlength']"
                            class="text-danger">
                            Message cannot be longer than 480 characters.
                        </div>
                    </div>
                </form>
                <div class="modal-footer mt-2">
                    <div class="d-block w-100 text-end">
                        <button type="button" class="btn btn-sm btn-primary me-2" (click)="sendEmailAndTextMessage()"
                            style="width: 80px;">Send</button>

                        <button type="button" #closeButton class="btn btn-sm btn-secondary" style="width: 80px;"
                            data-bs-dismiss="modal" aria-label="Close"
                            attr.data-bs-target="{{alertTruckerFilterModalId}}">Cancel</button>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span *ngIf="response?.status == 'Success'"
                                [ngStyle]="{'color' : 'green'}">{{response?.data}}</span>
                            <span *ngIf="response?.status == 'Error'" class="text-danger">{{response?.data}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>